import { render, staticRenderFns } from "./AddOnlinePayment.vue?vue&type=template&id=fc6acae4"
import script from "./AddOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddOnlinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports